import { useTranslate } from "@refinedev/core";
import type { ChatbotAnswerScope, ChatbotTone } from "../types";

const KEY = "createExperience.addOns.aiChat";

/**
 * Select options for the AI Chat add-on config card.
 */
export const useChatbotConfigData = () => {
  const t = useTranslate();

  // Option values ARE the API enums, so the stored form value needs no
  // translation — typed against them so a backend rename fails the build here
  // rather than silently sending an unknown value.
  const answerScopeOptions: { value: ChatbotAnswerScope; label: string }[] = [
    { value: "Grounded", label: t(`${KEY}.answerScope.grounded`) },
    { value: "Full", label: t(`${KEY}.answerScope.full`) },
    { value: "CitationsOnly", label: t(`${KEY}.answerScope.citationsOnly`) },
  ];

  const toneOptions: { value: ChatbotTone; label: string }[] = [
    { value: "Friendly", label: t(`${KEY}.tone.friendly`) },
    { value: "Professional", label: t(`${KEY}.tone.professional`) },
    { value: "Concise", label: t(`${KEY}.tone.concise`) },
  ];

  return {
    answerScopeOptions,
    toneOptions,
  };
};
